/* ==========================================================================
   Pilatix Track Order — pltx2-track-order.js
   Premium order tracking with HFD + Shopify integration
   ========================================================================== */

(function () {
  'use strict';

  const root = document.querySelector('.pltx2-track');
  if (!root) return;

  // Config from data attributes (set by Liquid section)
  const API_BASE = root.dataset.apiBase || '';
  const API_KEY = root.dataset.apiKey || '';
  let productThumbnails = {};
  try { productThumbnails = JSON.parse(root.dataset.productThumbnails || '{}'); } catch (e) { /* ignore */ }

  // DOM refs
  const $ = id => document.getElementById(id);
  const btn = $('pltx2Btn');
  const sf = $('fShip');
  const pf = $('fPhone');
  const errShip = $('errShip');
  const errPhone = $('errPhone');
  const formSection = root.querySelector('.pltx2-track__form-section');
  const result = $('pltx2Result');
  const sheet = $('helpSheet');

  // Desktop title toggle
  const mq = matchMedia('(min-width:750px)');
  const dt = root.querySelector('.pltx2-track__dtitle');
  function onMQ(e) { if (dt) dt.style.display = e.matches ? 'block' : 'none'; }
  mq.addEventListener('change', onMQ);
  onMQ(mq);

  // ===== EVENT DELEGATION (replaces inline onclick) =====
  document.addEventListener('click', function (e) {
    const action = e.target.closest('[data-action]');
    if (!action) return;
    const name = action.dataset.action;
    if (name === 'close-sheet') closeSheet();
    if (name === 'retry') retry();
    if (name === 'open-sheet') openSheet();
    if (name === 'show-all-events') showAllEvents(action);
  });

  // Close sheet when clicking overlay area (outside the panel)
  if (sheet) sheet.addEventListener('click', function (e) {
    if (e.target === sheet) closeSheet();
  });

  // Bottom sheet (matches reviews pattern: display toggle + class for animation)
  var savedScrollY = 0;
  var waBubble = document.querySelector('.pilatix-wa-bubble');

  function openSheet() {
    if (sheet) {
      savedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.style.insetInline = '0';
      if (waBubble) waBubble.style.display = 'none';
      sheet.style.display = 'flex';
      sheet.offsetHeight; // force reflow so transition fires
      sheet.classList.add('pltx2-sheet--open');
    }
  }

  function closeSheet() {
    if (sheet) {
      sheet.classList.remove('pltx2-sheet--open');
      var y = savedScrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.insetInline = '';
      window.scrollTo({ top: y, behavior: 'instant' });
      setTimeout(function () {
        if (sheet) sheet.style.display = 'none';
        if (waBubble) waBubble.style.display = '';
      }, 400);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && sheet.classList.contains('pltx2-sheet--open')) closeSheet();
  });

  // Clear field errors on input
  if (sf) sf.addEventListener('input', function () {
    sf.classList.remove('pltx2-track__field--error');
    if (errShip) errShip.classList.remove('pltx2-track__field-error--show');
  });
  if (pf) pf.addEventListener('input', function () {
    pf.classList.remove('pltx2-track__field--error');
    if (errPhone) errPhone.classList.remove('pltx2-track__field-error--show');
  });

  // Clean pasted text — strip non-digits (fixes WhatsApp/cookie banner junk)
  if (sf) sf.addEventListener('paste', function (e) {
    e.preventDefault();
    var text = (e.clipboardData || window.clipboardData).getData('text');
    sf.value = text.replace(/\D/g, '');
  });
  if (pf) pf.addEventListener('paste', function (e) {
    e.preventDefault();
    var text = (e.clipboardData || window.clipboardData).getData('text');
    pf.value = text.replace(/[^\d+\-\s]/g, '').trim();
  });

  // Form submit handling
  var form = $('pltx2Form');
  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); track(); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); track(); }
    });
  }

  // Button click
  if (btn) btn.addEventListener('click', track);

  // ===== HELPERS =====

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  function setBtn(state) {
    if (!btn) return;
    btn.dataset.state = state;
    btn.disabled = state !== 'idle';
  }

  function showFieldError(field, errEl) {
    if (field) field.classList.add('pltx2-track__field--error');
    if (errEl) errEl.classList.add('pltx2-track__field-error--show');
  }

  function clearErrors() {
    if (sf) sf.classList.remove('pltx2-track__field--error');
    if (pf) pf.classList.remove('pltx2-track__field--error');
    if (errShip) errShip.classList.remove('pltx2-track__field-error--show');
    if (errPhone) errPhone.classList.remove('pltx2-track__field-error--show');
  }

  function showResult(html) {
    if (formSection) formSection.classList.add('pltx2-track__form-section--hidden');
    if (result) {
      result.innerHTML = html;
      result.className = 'pltx2-track__result pltx2-track__result--show';
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function formatPrice(price, currency) {
    var num = Number(price);
    if (isNaN(num)) return price;
    var symbol = (currency === 'ILS' || !currency) ? '₪' : currency + ' ';
    return symbol + num.toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ===== MAIN TRACK FUNCTION =====

  function track() {
    var ship = sf ? sf.value.trim() : '';
    var phone = pf ? pf.value.trim() : '';

    clearErrors();

    // Normalize phone: strip dashes, spaces, leading +972 → 0
    phone = phone.replace(/[\s\-()]/g, '');
    if (phone.indexOf('+972') === 0) phone = '0' + phone.slice(4);
    if (phone.indexOf('972') === 0 && phone.length === 12) phone = '0' + phone.slice(3);

    // Validate
    var hasError = false;
    if (!ship || !/^\d{4,}$/.test(ship)) { showFieldError(sf, errShip); hasError = true; }
    if (!phone || !/^05\d{8}$/.test(phone)) {
      if (errPhone) errPhone.textContent = !phone ? pltxT('pltx2.js.k058', 'נא להזין מספר טלפון') : pltxT('pltx2.js.k052', 'מספר טלפון ישראלי לא תקין');
      showFieldError(pf, errPhone);
      hasError = true;
    }
    if (hasError) {
      (!ship && sf ? sf : pf).focus();
      return;
    }
    if (pf) pf.value = phone;

    // Loading with cycling messages
    setBtn('loading');
    var loadingMsgs = [pltxT('pltx2.js.k050', 'מחפש את המשלוח...'), pltxT('pltx2.js.k016', 'בודק פרטי הזמנה...'), pltxT('pltx2.js.k036', 'כמעט שם...')];
    var msgIdx = 0;
    var loadingInterval = setInterval(function () {
      msgIdx++;
      if (msgIdx < loadingMsgs.length && btn) {
        var txt = btn.querySelector('.pltx2-track__btn-loading-text');
        if (txt) txt.textContent = loadingMsgs[msgIdx];
      }
    }, 800);

    // Reset loading text for next time
    function resetLoadingText() {
      if (btn) {
        var txt = btn.querySelector('.pltx2-track__btn-loading-text');
        if (txt) txt.textContent = loadingMsgs[0];
      }
    }

    // API call
    fetch(API_BASE + '/api/track-shipment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': API_KEY,
      },
      body: JSON.stringify({ shipNum: ship, phone: phone }),
    })
      .then(function (r) {
        if (r.status === 429) throw new Error('rate_limit');
        if (!r.ok) throw new Error('server_error');
        return r.json();
      })
      .then(function (data) {
        clearInterval(loadingInterval);
        resetLoadingText();

        if (data.found) {
          setBtn('success');
          setTimeout(function () {
            setBtn('idle');
            renderResult(data, ship);
          }, 700);
        } else {
          setBtn('error');
          setTimeout(function () {
            setBtn('idle');
            renderError(data.message);
          }, 700);
        }
      })
      .catch(function (err) {
        clearInterval(loadingInterval);
        resetLoadingText();
        setBtn('error');
        setTimeout(function () {
          setBtn('idle');
          var msg = err.message === 'rate_limit'
            ? pltxT('pltx2.js.k033', 'יותר מדי בקשות, נסו שוב מאוחר יותר')
            : pltxT('pltx2.js.k090', 'שגיאת תקשורת, נסו שוב מאוחר יותר');
          renderError(msg);
        }, 700);
      });
  }

  // ===== RENDER ERROR =====

  function renderError(message) {
    // Hide help trigger
    root.querySelectorAll('.pltx2-track__help')
      .forEach(function (el) { el.style.display = 'none'; });

    showResult(
      '<div class="pltx2-track__result-card pltx2-track__result-card--fail">' +
        '<div class="pltx2-track__result-badge pltx2-track__result-badge--fail">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</div>' +
        '<div class="pltx2-track__result-h">' + pltxT('pltx2.js.k042', 'לא נמצאה התאמה') + '</div>' +
        '<div class="pltx2-track__result-p">' + esc(message || pltxT('pltx2.js.k012', 'בדקו שמספר המשלוח ומספר הטלפון נכונים. הטלפון צריך להיות זהה לזה שהוזן בעת ההזמנה.')) + '</div>' +
        '<button class="pltx2-track__result-retry" data-action="retry">' + pltxT('pltx2.js.k066', 'נסו שוב') + '</button>' +
      '</div>'
    );
  }

  // ===== RENDER RESULT (SUCCESS) =====

  function renderResult(data, shipNum) {
    var ev = (data.tracking && data.tracking.events) || [];
    var c = data.customer;
    var o = data.order;
    var latestStatus = ev.length > 0 ? ev[0].desc : '';

    // Determine step (0=received, 1=warehouse, 2=onTheWay, 3=delivered)
    var currentStep = 0;
    var statusLabel = pltxT('pltx2.js.k021', 'ההזמנה התקבלה');
    var statusClass = '';
    var isDelivered = false;

    if (latestStatus.indexOf(pltxT('pltx2.js.k063', 'נמסר')) !== -1 || latestStatus.indexOf(pltxT('pltx2.js.k065', 'נסגרה')) !== -1) {
      currentStep = 3; statusLabel = pltxT('pltx2.js.k064', 'נמסר בהצלחה!'); statusClass = ' pltx2-track__status-headline--delivered'; isDelivered = true;
    } else if (latestStatus.indexOf(pltxT('pltx2.js.k014', 'בדרך')) !== -1 || latestStatus.indexOf(pltxT('pltx2.js.k028', 'הפצה')) !== -1 || latestStatus.indexOf(pltxT('pltx2.js.k045', 'לפני הפצה')) !== -1) {
      currentStep = 2; statusLabel = pltxT('pltx2.js.k015', 'בדרך אליכם');
    } else if (latestStatus.indexOf(pltxT('pltx2.js.k049', 'מחסן')) !== -1 || latestStatus.indexOf(pltxT('pltx2.js.k067', 'נקלט')) !== -1 || latestStatus.indexOf(pltxT('pltx2.js.k059', 'נאסף')) !== -1) {
      currentStep = 1; statusLabel = pltxT('pltx2.js.k068', 'נקלט במחסן');
    }

    var linePct = [0, 33, 66, 100][currentStep];

    function stepCls(i) {
      if (isDelivered) return 'pltx2-track__step--delivered';
      if (i < currentStep) return 'pltx2-track__step--done';
      if (i === currentStep) return 'pltx2-track__step--active';
      return '';
    }

    // Timeline HTML
    var timelineHtml = ev.map(function (e) {
      return '<div class="pltx2-track__timeline-item">' +
        '<div class="pltx2-track__timeline-dot"></div>' +
        '<div class="pltx2-track__timeline-info">' +
          '<div class="pltx2-track__timeline-desc">' + esc(e.desc) + '</div>' +
          '<div class="pltx2-track__timeline-date">' + esc(e.date) + ' · ' + esc(e.time) + '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    // Hide irrelevant elements
    if (formSection) formSection.classList.add('pltx2-track__form-section--hidden');
    root.querySelectorAll('.pltx2-track__help, .pltx2-track__divider')
      .forEach(function (el) { el.style.display = 'none'; });

    // Build HTML
    var html = '';

    // Customer greeting (only if Shopify matched)
    if (c) {
      var initials = (c.firstName ? c.firstName[0] : '') + (c.lastName ? c.lastName[0] : '');
      html += '<div class="pltx2-track__customer">' +
        '<div class="pltx2-track__customer-avatar">' + esc(initials) + '</div>' +
        '<div class="pltx2-track__customer-info">' +
          '<div class="pltx2-track__customer-greeting">' + pltxT('pltx2.js.k026', 'היי, מצאנו את ההזמנה שלך') + '</div>' +
          '<div class="pltx2-track__customer-name">' + esc(c.firstName) + ' ' + esc(c.lastName) + '</div>' +
        '</div>' +
      '</div>';
    }

    // Due date + driver info from HFD REST API
    var dueDate = data.tracking && data.tracking.dueDate;
    var driverName = data.tracking && data.tracking.driverName;

    // Status + Steps
    html += '<div class="pltx2-track__status">' +
      '<div class="pltx2-track__status-top">' +
        '<div class="pltx2-track__status-label">' + pltxT('pltx2.js.k070', 'סטטוס משלוח') + '</div>' +
        '<div class="pltx2-track__status-headline' + statusClass + '">' + statusLabel + '</div>' +
      '</div>';

    // Shipment info (due date + driver)
    if (dueDate || (driverName && currentStep === 2)) {
      html += '<div class="pltx2-track__shipment-info">';
      if (dueDate) {
        html += '<div class="pltx2-track__info-row">' +
          '<div class="pltx2-track__info-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></div>' +
          '<div class="pltx2-track__info-content">' +
            '<span class="pltx2-track__info-label">' + pltxT('pltx2.js.k077', 'צפי מסירה') + '</span>' +
            '<span class="pltx2-track__info-value">' + esc(dueDate) + '</span>' +
          '</div>' +
        '</div>';
      }
      if (driverName && currentStep === 2) {
        html += '<div class="pltx2-track__info-row">' +
          '<div class="pltx2-track__info-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg></div>' +
          '<div class="pltx2-track__info-content">' +
            '<span class="pltx2-track__info-label">' + pltxT('pltx2.js.k092', 'שליח') + '</span>' +
            '<span class="pltx2-track__info-value">' + esc(driverName) + '</span>' +
          '</div>' +
        '</div>';
      }
      html += '<div class="pltx2-track__info-disclaimer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>' +
        pltxT('pltx2.js.k078', 'צפי מסירה לפי חברת המשלוחים HFD. התאריך עלול להשתנות.') +
      '</div></div>';
    }

    html += '<div class="pltx2-track__steps">' +
        '<div class="pltx2-track__steps-line">' +
          '<div class="pltx2-track__steps-line-fill' + (isDelivered ? ' pltx2-track__steps-line-fill--done' : '') + '" style="width:0%;" data-target="' + linePct + '"></div>' +
        '</div>' +
        '<div class="pltx2-track__step ' + stepCls(0) + '">' +
          '<div class="pltx2-track__step-icon"><svg viewBox="0 0 24 24"><path d="M21 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2"/><path d="M3 8l9 5 9-5"/><rect x="1" y="8" width="22" height="14" rx="2"/></svg></div>' +
          '<span class="pltx2-track__step-label">' + pltxT('pltx2.js.k025', 'הזמנה') + '<br>' + pltxT('pltx2.js.k031', 'התקבלה') + '</span>' +
        '</div>' +
        '<div class="pltx2-track__step ' + stepCls(1) + '">' +
          '<div class="pltx2-track__step-icon"><svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg></div>' +
          '<span class="pltx2-track__step-label">' + pltxT('pltx2.js.k019', 'במחסן') + '</span>' +
        '</div>' +
        '<div class="pltx2-track__step ' + stepCls(2) + '">' +
          '<div class="pltx2-track__step-icon"><svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></div>' +
          '<span class="pltx2-track__step-label">' + pltxT('pltx2.js.k014', 'בדרך') + '<br>' + pltxT('pltx2.js.k009', 'אליכם') + '</span>' +
        '</div>' +
        '<div class="pltx2-track__step ' + stepCls(3) + '">' +
          '<div class="pltx2-track__step-icon"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg></div>' +
          '<span class="pltx2-track__step-label">' + pltxT('pltx2.js.k063', 'נמסר') + '</span>' +
        '</div>' +
      '</div>' +
    '</div>';

    // Order details (only if Shopify matched)
    if (o) {
      var addr = o.shippingAddress;

      // Order header
      html += '<div class="pltx2-track__order-header">' +
        '<div class="pltx2-track__order-header-title">' + pltxT('pltx2.js.k022', 'ההזמנה שלך') + '</div>' +
        '<div class="pltx2-track__order-header-meta">' +
          '<span>' + esc(o.name) + '</span>' +
          '<span class="pltx2-track__order-header-sep"></span>' +
          '<span>' + esc(o.date) + '</span>' +
        '</div>' +
      '</div>';

      // Products
      var productsHtml = '';
      if (o.products && o.products.length > 0) {
        o.products.forEach(function (p) {
          var thumbUrl = productThumbnails[p.productId] || p.imageUrl;
          var placeholderSvg = '<div class="pltx2-track__product-img-placeholder"><svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/><path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/><path d="M18 12a2 2 0 0 0 0 4h4v-4Z"/></svg></div>';
          var imgHtml = thumbUrl
            ? '<img class="pltx2-track__product-img" src="' + esc(thumbUrl) + '" alt="' + esc(p.title) + '" loading="lazy">'
            : placeholderSvg;
          var isGift = Number(p.price) === 0;
          var badgeHtml = isGift ? ' <span class="pltx2-track__product-badge">' + pltxT('pltx2.js.k057', 'מתנה') + '</span>' : '';
          var priceHtml = isGift ? '' : '<div class="pltx2-track__product-price">' + formatPrice(p.price, o.currency) + '</div>';

          productsHtml += '<div class="pltx2-track__product">' +
            imgHtml +
            '<div class="pltx2-track__product-info">' +
              '<div class="pltx2-track__product-name">' + esc(p.title) + badgeHtml + '</div>' +
              '<div class="pltx2-track__product-variant">' + (p.variant ? esc(p.variant) + ' · ' : '') + pltxT('pltx2.js.k035', 'כמות: ') + esc(p.qty) + '</div>' +
              priceHtml +
            '</div>' +
          '</div>';
        });
      }

      if (productsHtml) {
        html += '<div class="pltx2-track__order-section">' + productsHtml + '</div>';
      }

      // Details with icons
      html += '<div class="pltx2-track__details">';
      if (addr) {
        html += '<div class="pltx2-track__detail-row"><span class="pltx2-track__detail-key"><svg viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>' + pltxT('pltx2.js.k038', 'כתובת למשלוח') + '</span><span class="pltx2-track__detail-val">' + esc(addr.address1) + ', ' + esc(addr.city) + '</span></div>';
      }
      html += '<div class="pltx2-track__detail-row"><span class="pltx2-track__detail-key"><svg viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>' + pltxT('pltx2.js.k069', 'סה״כ שולם') + '</span><span class="pltx2-track__detail-val pltx2-track__detail-val--bold">' + formatPrice(o.totalPrice, o.currency) + '</span></div>';
      if (o.shipping) {
        var shippingLabel = Number(o.shipping.price) === 0 ? pltxT('pltx2.js.k056', 'משלוח חינם!') : formatPrice(o.shipping.price, o.currency);
        html += '<div class="pltx2-track__detail-row"><span class="pltx2-track__detail-key"><svg viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' + pltxT('pltx2.js.k055', 'משלוח') + '</span><span class="pltx2-track__detail-val' + (Number(o.shipping.price) === 0 ? ' pltx2-track__detail-val--free' : '') + '">' + esc(shippingLabel) + '</span></div>';
      }
      if (c && c.email) {
        html += '<div class="pltx2-track__detail-row"><span class="pltx2-track__detail-key"><svg viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' + pltxT('pltx2.js.k051', 'מייל') + '</span><span class="pltx2-track__detail-val">' + esc(c.email) + '</span></div>';
      }
      html += '<div class="pltx2-track__detail-row"><span class="pltx2-track__detail-key"><svg viewBox="0 0 24 24"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 8h20"/><path d="M9 4v4"/><path d="M15 4v4"/><circle cx="12" cy="15" r="2"/></svg>' + pltxT('pltx2.js.k053', 'מספר משלוח') + '</span><span class="pltx2-track__detail-val">' + esc(shipNum) + '</span></div>' +
      '</div>';
    }

    // Timeline
    if (timelineHtml) {
      html += '<div class="pltx2-track__timeline">' +
        '<div class="pltx2-track__timeline-header"><span class="pltx2-track__timeline-title">' + pltxT('pltx2.js.k027', 'היסטוריית משלוח') + '</span></div>' +
        '<div class="pltx2-track__timeline-list">' + timelineHtml + '</div>' +
      '</div>';
    }

    // Search again
    html += '<div class="pltx2-track__search-again"><button data-action="retry"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' + pltxT('pltx2.js.k032', 'חיפוש משלוח נוסף') + '</button></div>';

    if (result) {
      result.innerHTML = html;
      result.className = 'pltx2-track__result pltx2-track__result--show';
    }

    // Animate step line
    requestAnimationFrame(function () {
      var fill = result ? result.querySelector('.pltx2-track__steps-line-fill') : null;
      if (fill) {
        requestAnimationFrame(function () {
          fill.style.width = fill.dataset.target + '%';
        });
      }
    });

    if (result) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ===== SHOW ALL EVENTS =====

  function showAllEvents(el) {
    var extras = el.parentElement.querySelectorAll('[data-extra]');
    extras.forEach(function (item) { item.style.display = ''; });
    el.remove();
  }

  // ===== RETRY =====

  function retry() {
    if (result) {
      result.className = 'pltx2-track__result';
      result.innerHTML = '';
    }
    if (formSection) formSection.classList.remove('pltx2-track__form-section--hidden');

    // Restore hidden elements
    root.querySelectorAll('.pltx2-track__help, .pltx2-track__divider')
      .forEach(function (el) { el.style.display = ''; });

    if (sf) sf.value = '';
    if (pf) pf.value = '';
    clearErrors();
    setTimeout(function () {
      if (sf) {
        sf.focus();
        sf.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

})();
